import { render, staticRenderFns } from "./TaskOrderItem.vue?vue&type=template&id=5f6c42dc"
import script from "./TaskOrderItem.vue?vue&type=script&lang=js"
export * from "./TaskOrderItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports